import { useEffect, useRef } from 'react';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

/**
 * Anteprima non interattiva della zona scelta: mostra il poligono disegnato
 * (area) oppure un cerchio attorno al punto (center). Marina 2026-07-12.
 */
export default function AreaPreview({ area, center, bounds, italy, height = 168, onClick, badge = 'Modifica', radius = 14, bordered = true }) {
  const ref = useRef(null);

  useEffect(() => {
    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    if (!key || !ref.current) return;
    let cancelled = false;
    if (!(window.google && window.google.maps)) {
      try { setOptions({ key, v: 'weekly' }); } catch (_) {}
    }
    Promise.all([importLibrary('core'), importLibrary('maps')]).then(() => {
      if (cancelled || !ref.current) return;
      const g = window.google;
      const map = new g.maps.Map(ref.current, {
        disableDefaultUI: true, gestureHandling: 'none', keyboardShortcuts: false,
        clickableIcons: false, zoomControl: false, draggable: false,
        center: { lat: 41.9028, lng: 12.4964 }, zoom: 6,
      });
      if (area && area.length >= 3) {
        // Area disegnata → poligono
        new g.maps.Polygon({
          paths: area, map, strokeColor: '#1F6FEB', strokeWeight: 2.5, strokeOpacity: 0.95,
          fillColor: '#1F6FEB', fillOpacity: 0.12, clickable: false,
        });
        const b = new g.maps.LatLngBounds();
        area.forEach((p) => b.extend(p));
        map.fitBounds(b, 26);
      } else if (bounds && bounds.south != null && bounds.north != null) {
        // Viewport reale della zona (da Google): rettangolo che ne segue i confini
        const b = new g.maps.LatLngBounds({ lat: bounds.south, lng: bounds.west }, { lat: bounds.north, lng: bounds.east });
        new g.maps.Rectangle({
          bounds: b, map, strokeColor: '#1F6FEB', strokeWeight: 2, strokeOpacity: 0.9,
          fillColor: '#1F6FEB', fillOpacity: 0.10, clickable: false,
        });
        map.fitBounds(b, 18);
      } else if (italy) {
        // Tutta Italia
        map.fitBounds(new g.maps.LatLngBounds({ lat: 36.4, lng: 6.5 }, { lat: 47.2, lng: 18.6 }), 8);
      } else if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        // Fallback: cerchio attorno al punto
        map.setCenter(center); map.setZoom(13);
        new g.maps.Circle({
          map, center, radius: 1800, strokeColor: '#1F6FEB', strokeWeight: 2, strokeOpacity: 0.9,
          fillColor: '#1F6FEB', fillOpacity: 0.12, clickable: false,
        });
      }
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(area || null), JSON.stringify(bounds || null), italy, center && center.lat, center && center.lng]);

  return (
    <div onClick={onClick} style={{
      position: 'relative', height, borderRadius: radius, overflow: 'hidden',
      cursor: onClick ? 'pointer' : 'default', border: bordered ? '1px solid #E4E6EA' : 'none',
    }}>
      <div ref={ref} style={{ position: 'absolute', inset: 0 }} />
      {/* blocca ogni interazione: è solo un'anteprima */}
      <div style={{ position: 'absolute', inset: 0 }} />
      {onClick && badge && (
        <div style={{
          position: 'absolute', right: 10, bottom: 10, background: 'rgba(255,255,255,0.96)',
          borderRadius: 9, padding: '6px 11px', fontSize: 12.5, fontWeight: 800, color: '#1F2937',
          boxShadow: '0 2px 8px rgba(0,0,0,0.16)', fontFamily: 'Manrope, system-ui, sans-serif',
        }}>{badge}</div>
      )}
    </div>
  );
}
